const VIEW_SWITCHER_SELECTOR = '#lead-board-tour-view-switcher';

function clickTab(label: string): void {
    const tab = document.querySelector<HTMLElement>(
        `${VIEW_SWITCHER_SELECTOR} [data-tip="${label}"] button`
    );
    tab?.click();
}

/**
 * Cycles through map -> list -> board views with timed delays.
 * Returns a cleanup function that cancels pending transitions
 * and restores the board view.
 */
export function simulateViewSwitcher(): (() => void) | void {
    const timers: number[] = [];
    let cancelled = false;

    const schedule = (fn: () => void, ms: number) => {
        timers.push(
            window.setTimeout(() => {
                if (!cancelled) fn();
            }, ms)
        );
    };

    schedule(() => clickTab('Map'), 800);
    schedule(() => clickTab('List'), 800 + 4000);
    schedule(() => clickTab('Board'), 800 + 4000 + 3000);

    return () => {
        cancelled = true;
        timers.forEach((t) => window.clearTimeout(t));
        clickTab('Board');
    };
}
